import { useSignals } from '@preact/signals-react/runtime';
import { useLayoutEffect } from 'react';
import { ConversationDomainModel } from './conversation-model';
import { createWebConversationTransport } from './conversation-transport';

const websiteConversationDomainModelKey =
  '__cueboard_website_conversation_domain_model__';

type WebsiteConversationDomainModelGlobal = typeof globalThis & {
  [websiteConversationDomainModelKey]?: ConversationDomainModel;
};

const globalObject = globalThis as WebsiteConversationDomainModelGlobal;

export const websiteConversationDomainModel =
  globalObject[websiteConversationDomainModelKey] ??
  (globalObject[websiteConversationDomainModelKey] =
    new ConversationDomainModel({
      transport: createWebConversationTransport(),
    }));

function disposeWebsiteConversationDomainModel() {
  websiteConversationDomainModel.dispose();
  if (
    globalObject[websiteConversationDomainModelKey] ===
    websiteConversationDomainModel
  ) {
    delete globalObject[websiteConversationDomainModelKey];
  }
}

const conversationDomainModelHot = (
  import.meta as ImportMeta & {
    hot?: { dispose(callback: () => void): void };
  }
).hot;
conversationDomainModelHot?.dispose(disposeWebsiteConversationDomainModel);

export function resetWebsiteConversationDomainModelForTests() {
  websiteConversationDomainModel.resetForTest();
}

export function useConversationDomainModel() {
  websiteConversationDomainModel.ensureStarted();
  useSignals();
  return websiteConversationDomainModel;
}

export function useRoutedConversationDomainModel(
  routeConversationId: string | null | undefined,
  routeAgentGroupId?: string | null | undefined
) {
  const model = useConversationDomainModel();
  useLayoutEffect(() => {
    model.setRoute(routeConversationId, { agentGroupId: routeAgentGroupId });
  }, [model, routeAgentGroupId, routeConversationId]);
  return model;
}
